/**
 * ProcurementRoleTypeService
 * Service for ProcurementRoleType entity operations
 * Route: api/procurementroletype
 * Controller: ProcurementRoleTypeController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProcurementRoleTypeService
 * Handles procurement role type CRUD operations
 * Maps to /api/procurementroletype endpoint
 */
export class ProcurementRoleTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProcurementRoleTypeService.DEFAULT_SERVICE_PATH,
            basePath: ProcurementRoleTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProcurementRoleTypeService.DEFAULT_SERVICE_PATH = 'procurements';
ProcurementRoleTypeService.BASE_PATH = 'api/procurementroletype';
//# sourceMappingURL=ProcurementRoleTypeService.js.map